var map = {
	"./DrLubhani/ChangeColor": [
		780,
		187
	],
	"./Ganga/ChangeColor": [
		782,
		193
	],
	"./Indus/ChangeColor": [
		784,
		206
	],
	"./Kabini/ChangeColor": [
		786,
		213
	],
	"./Kaveri/ChangeColor": [
		690,
		21
	],
	"./Luni/ChangeColor": [
		788,
		219
	],
	"./Narmada/ChangeColor": [
		790,
		222
	],
	"./Neyyar/ChangeColor": [
		792,
		229
	],
	"./Periyar/ChangeColor": [
		794,
		232
	],
	"./SAANVI/ChangeColor": [
		796,
		242
	],
	"./Sabarmathi/ChangeColor": [
		798,
		249
	],
	"./Sparsh - Copy/ChangeColor": [
		802,
		255
	],
	"./Sparsh/ChangeColor": [
		800,
		259
	],
	"./Sutlej/ChangeColor": [
		804,
		263
	],
	"./Yamuna/ChangeColor": [
		806,
		269
	],
	"./pamba/ChangeColor": [
		808,
		278
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 2058;
module.exports = webpackAsyncContext;